// extracted by mini-css-extract-plugin
module.exports = {"matchListWrapper":"MatchList_matchListWrapper__1oBgy","matchListHeader":"MatchList_matchListHeader__CmjSJ","placeholder":"MatchList_placeholder__139H-"};